import { render, staticRenderFns } from "./MySprkr.vue?vue&type=template&id=7d28b9e0&"
import script from "./MySprkr.vue?vue&type=script&lang=js&"
export * from "./MySprkr.vue?vue&type=script&lang=js&"
import style0 from "./MySprkr.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports